const toCssWidth = (width) => {
    if (width === undefined || width === null || width === '') return undefined;
    if (typeof width === 'number') return `${width}rem`;
    return /^[0-9.]+$/.test(String(width)) ? `${width}rem` : String(width);
};

export const getColumnStyle = (colConf, columnIndex, colConfig) => {
    const fallbackWidth = colConfig?.widths?.[columnIndex + 2];
    const customStyle = colConf?.columnStyle || {};
    const configuredWidth = customStyle.width ?? colConf?.style?.width;
    const width = toCssWidth(configuredWidth) || toCssWidth(fallbackWidth === undefined ? undefined : fallbackWidth / 2.5);

    return {
        ...(typeof customStyle === 'object' ? customStyle : {}),
        ...(width ? { width, minWidth: '64px', maxWidth: width } : { minWidth: '64px' })
    };
};

export const getHeaderColor = (color, fallback) => {
    const argb = color?.argb;
    return argb ? `#${argb.replace(/^FF/, '')}` : fallback;
};
